import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["path", "onClick", "children", "innerRef", "component"];
import TrackedLink from '../TrackedLink';
import useDemoExitConfirmationComponent from '../../hooks/useDemoExitConfirmationComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export const ButtonWithDemoExitConfirmation = props => {
  const {
      path,
      onClick,
      children,
      innerRef,
      component: Component = TrackedLink
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    onNavLinkClick
  } = useDemoExitConfirmationComponent();
  const handleClick = event => {
    if (onClick) {
      onClick();
    }
    const navUrl = path || otherProps.href || otherProps.link;
    onNavLinkClick(event, navUrl);
  };
  return /*#__PURE__*/_jsx(Component, Object.assign({
    ref: innerRef,
    onClick: handleClick
  }, otherProps, {
    children: children
  }));
};